import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
	open(e) {
		e.preventDefault();

		let shareTitle = document.title;
		let pageUrl = window.location.href;
		let shareData = {
			title: shareTitle,
			url: pageUrl,
		};

		if (navigator.canShare(shareData)) {
			navigator
				.share({
					title: shareTitle,
					url: pageUrl,
				})
				.then(() => {})
				.catch((error) => {
					console.log('Sorry, there was a problem with the share.');
				});
		}
	}
}
